module.exports = __webpack_public_path__ + "img/4h.0db8d44c.png";